import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { useAuth } from '@/libs/hooks/use-auth'

export const Route = createFileRoute('/auth')({
  validateSearch: z.object({
    redirectTo: z.string().optional(),
  }),
  beforeLoad: async ({ preload, search }) => {
    if (preload) return
    const { isAuthenticated } = useAuth.getState()
    if (isAuthenticated) {
      let to = '/'
      if (search.redirectTo) {
        to = search.redirectTo
      }

      throw redirect({
        from: Route.path,
        to,
      })
    }
  },
  component: Component,
})

function Component() {
  return (
    <div className="flex min-h-lvh items-center justify-center bg-ui-bg-base">
      <Outlet />
    </div>
  )
}
